// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.7474 18.3346V14.168M3.7474 5.83464V1.66797M1.66406 3.7513H5.83073M1.66406 16.2513H5.83073M10.8307 2.5013L9.38558 6.25869C9.15057 6.86971 9.03307 7.17522 8.85034 7.43221C8.68839 7.65997 8.48939 7.85896 8.26163 8.02091C8.00465 8.20364 7.69914 8.32114 7.08811 8.55615L3.33073 10.0013L7.08811 11.4465C7.69914 11.6815 8.00465 11.799 8.26163 11.9817C8.48939 12.1436 8.68839 12.3426 8.85034 12.5704C9.03307 12.8274 9.15057 13.1329 9.38558 13.7439L10.8307 17.5013L12.2759 13.7439C12.5109 13.1329 12.6284 12.8274 12.8111 12.5704C12.9731 12.3426 13.1721 12.1436 13.3998 11.9817C13.6568 11.799 13.9623 11.6815 14.5733 11.4464L18.3307 10.0013L14.5733 8.55615C13.9623 8.32114 13.6568 8.20364 13.3998 8.02091C13.1721 7.85896 12.9731 7.65997 12.8111 7.43221C12.6284 7.17523 12.5109 6.86971 12.2759 6.25869L10.8307 2.5013Z"
    />
  </svg>
);
const IconAi = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconAi;
